import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { GraduationList } from '../../../types/personShow';

type Props = {
  onChangedBody: (name: string, value: string) => void;
  graduationYear: string;
  graduationList: GraduationList;
  target: string;
};

export const Component: FunctionComponent<Props> = ({ onChangedBody, graduationYear, graduationList, target }) => {
  const [selectedYear, setSelectedYear] = useState('');

  useEffect(() => {
    setSelectedYear(graduationYear);
  }, [graduationYear]);

  const handleChange = (event: React.MouseEvent<HTMLLIElement>) => {
    const value = (event.currentTarget.children[0] as HTMLElement).dataset.id;
    if (!value) return;
    const formatted = value === 'その他' || value === '既卒' ? value : `${value}年卒`;
    onChangedBody(target, formatted);
  };

  return <Presentation selectedYear={selectedYear} graduationList={graduationList} handleChange={handleChange} />;
};
